import { rudderstackTrack } from 'src/helpers/rudderstack';
const track = (eventType: string, options: $TODOFIXME = {}) => rudderstackTrack(eventType, options);

export default track;
